import { render, staticRenderFns } from "./editHospital.vue?vue&type=template&id=4ef65ade&scoped=true"
import script from "./editHospital.vue?vue&type=script&lang=js"
export * from "./editHospital.vue?vue&type=script&lang=js"
import style0 from "./editHospital.vue?vue&type=style&index=0&id=4ef65ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef65ade",
  null
  
)

export default component.exports